import { humanizeHours } from 'works/legacy/lib/date-helper';

export function tierHumanizeVisibilityOffset(delayInHours?: number) {
  if (delayInHours === 0) {
    return '0 hours (No Delay)';
  }

  if (!delayInHours) {
    return '';
  }

  return humanizeHours(delayInHours);
}
